import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import Modalexpercommentbacktex from './Modalexpercommentbacktex';
import { URL,api } from '../../api';


export default class Commentexlist extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentex:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
        api.get('registercon/selectArticleforexpertlist/'+this.props.expert_id+'/'+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentex: res.data})
        }) 

      }, 0);

  }

  list() {
      setTimeout(() => {
        api.get('registercon/selectArticleforexpertlist/'+this.props.expert_id+'/'+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentex: res.data})
        }) 
      }, 0);
  }



    render() {
        

        return (
            <>
           <MDBTable small>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความ</th>
          <th>วันที่</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ไม่ผ่าน</th>
          <th>การส่งกลับ</th>
          
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentex.map((commentex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>
                           
                            <a href={`${this.state.url+commentex.fileclosenameword	}`}  target="_blank"><p className="indigo-text"><MDBIcon far icon="file-word" /> ไฟล์ที่ส่งตรวจ</p> </a>
                            <a href={`${this.state.url+commentex.fileclosenamepdf	}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์ที่ส่งตรวจ</p> </a>
                            </td>
                        <td>{commentex.date_sentexpert}</td>
                        <td className='text-center'>{commentex.filewordcomment_expert !== null ? <> <a href={`${this.state.url+commentex.filewordcomment_expert	}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a></>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td className='text-center'>{commentex.date_senbackexpert !== null ?<>{commentex.date_senbackexpert}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td className='text-center'>{commentex.statuscomment_expert==='1'?<>ผ่าน<br/>(ไม่มีแก้ไข)</>:<>
                        {commentex.statuscomment_expert==='2'?<>ผ่าน<br/>(มีแก้ไข)</>:<> {commentex.statuscomment_expert==='0'?<>เห็นควรปรับแก้ไขและดำเนินการส่งใหม่</>:<><MDBIcon far icon="hourglass" /></>}</>}   
                            </>}
                        </td>
                        <td>{commentex.statuscomment_expert !== null ?<>
                        ส่งกลับแล้ว
                        </>:<>
                          {commentex.statuscomment_expert==='1'?<>แจ้งกลับแล้ว</>:<>
                          <Modalexpercommentbacktex id_send={commentex.id_sendarticle} id_excomment={commentex.id_commentex} id_ex={commentex.id_expertex} list={this.list} name_article={commentex.name_article} />
                          </>}
                        
                        </>}
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


